"use client";
import { useState } from "react";
import { usePathname } from "next/navigation";
import Image from "next/image";
import Link from "next/link";
const links = [
  ["Examples", "/examples"],
  ["Photography Styles", "/styles"],
  ["Free Outfit Planner", "/outfit-planner"],
  ["Pricing", "/pricing"],
];
export default function MarketingHeader() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  const isPlanner = pathname === "/outfit-planner/planner";
  return (
    <header className={`nav${isPlanner ? " nav--planner" : ""}`}>
      <a className="skip-link btn" href="#main-content">
        Skip to content
      </a>
      <Link className="brand" href="/" aria-label="Provamoda home">
        <Image
          src="/logo-white.svg"
          width={168}
          height={30}
          alt="Provamoda"
          priority
        />
      </Link>
      <nav
        className={`navlinks${open ? " open" : ""}`}
        id="marketing-navigation"
        aria-label="Main navigation"
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            setOpen(false);
            document.getElementById("marketing-menu-toggle")?.focus();
          }
        }}
      >
        {links.map(([label, href]) => (
          <Link
            key={href}
            href={href}
            aria-current={
              pathname === href || pathname.startsWith(href + "/")
                ? "page"
                : undefined
            }
            onClick={() => setOpen(false)}
          >
            {label}
          </Link>
        ))}
        <Link
          className="mobile-login"
          href="/login"
          onClick={() => setOpen(false)}
        >
          Log In
        </Link>
      </nav>
      <div className="nav-end">
        <Link className="login btn ghost sm" href="/login">
          Log In
        </Link>
        {isPlanner && <div id="planner-header-actions" />}
        <button
          id="marketing-menu-toggle"
          className="menu-button"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="marketing-navigation"
          onClick={() => setOpen(!open)}
        >
          {open ? "×" : "☰"}
        </button>
      </div>
    </header>
  );
}
